import { render, staticRenderFns } from "./StatAverages.vue?vue&type=template&id=2952c936&"
import script from "./StatAverages.vue?vue&type=script&lang=js&"
export * from "./StatAverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports